"use strict";

exports.__esModule = true;
exports.default = void 0;
var getCurrencyAttributes = function getCurrencyAttributes(locale, currency) {
  if (currency === void 0) {
    currency = '$';
  }
  switch (locale) {
    case 'fr':
    case 'fr-CA':
    case 'fr_CA':
      return {
        prefix: '',
        thousandSeparator: ' ',
        decimalSeparator: ',',
        suffix: " " + currency
      };
    case 'en':
    case 'en-CA':
    case 'en_CA':
    default:
      return {
        prefix: currency + " ",
        thousandSeparator: ',',
        decimalSeparator: '.',
        suffix: ''
      };
  }
};
var _default = exports.default = getCurrencyAttributes;